import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import { SharedModule } from 'app/shared/shared.module';
import { UIComponentsModule } from 'app/ui-components/ui-components.module';

import { UserHeaderComponent } from './user-header/user-header.component';
import { UserInviteComponent } from './user-invite/user-invite.component';
import { UserListSearchBarComponent } from './user-list/user-list-search-bar/user-list-search-bar.component';
import { UserListSortingIconComponent } from './user-list/user-list-sorting-icon/user-list-sorting-icon.component';
import { ActiveUsersTableRowComponent } from './user-list/user-list-table/active-users-table-row/active-users-table-row.component';
import { PendingUsersTableRowComponent } from './user-list/user-list-table/pending-users-table-row/pending-users-table-row.component';
import { UsersTableHeaderComponent } from './user-list/user-list-table/users-table-header/users-table-header.component';
import { UserListComponent } from './user-list/user-list.component';
import { UserPermissionToggleComponent } from './user-permission-toggle/user-permission-toggle.component';
import { UserCompanyComponent } from './users-dashpivot/user-company/user-company.component';
import { UserProjectComponent } from './users-dashpivot/user-project/user-project.component';
import { UserTeamComponent } from './users-dashpivot/user-team/user-team.component';
import { UsersRoutingModule } from './users-routing.module';
import { FormUsersComponent } from './users-sitemate/form-users/form-users.component';
import { IdentityCardsComponent } from './users-sitemate/identity-cards/identity-cards.component';
import { TemplateLinksListModalComponent } from './users-sitemate/template-links-list-modal/template-links-list-modal.component';
import { UsersComponent } from './users.component';
import { SitemateApiModule } from '../sitemate-api/sitemate-api.module';

@NgModule({
  imports: [
    CommonModule,
    UsersRoutingModule,
    SharedModule,
    NgbModule,
    FormsModule,
    UIComponentsModule,
    NgSelectModule,
    SitemateApiModule,
  ],
  declarations: [
    FormUsersComponent,
    IdentityCardsComponent,
    TemplateLinksListModalComponent,
    UsersComponent,
    UserTeamComponent,
    UserProjectComponent,
    UserCompanyComponent,
    UserHeaderComponent,
    UserListComponent,
    UserInviteComponent,
    UserListSortingIconComponent,
    UserListSearchBarComponent,
    ActiveUsersTableRowComponent,
    PendingUsersTableRowComponent,
    UsersTableHeaderComponent,
    UserPermissionToggleComponent,
  ],
})
export class UsersModule {}
